import APIServer from "./APIServer";
import UtilsManager from '../managers/UtilsManager'

export default class PlaceAPI extends APIServer { 
    private utilsManager: UtilsManager;

    constructor() { 
        super();
        this.utilsManager = new UtilsManager();
    }

    async getPlaces({placeId=null, zone=null, blackOwned=false, page=1} = {}) {
        var url = "/place"
        const params = [];
        params.push({page: page})
        
        if (placeId) { 
            params.push({
                id: placeId 
            })
        }
        if (zone) { 
            params.push({zone: zone});
        }
        if (blackOwned) { 
            params.push({black_owned: blackOwned})
        }
        url += this.utilsManager.combineParamsV2(params)
        return await super.get(url)
    }
}